<template>
  <form
    :class="['form', { 'has-footer': showFooter, 'is-disabled': disabled }]"
    v-bind="$attrs"
    v-on="listeners"
  >
    <fieldset :class="['form-body', bodyClass]" :disabled="disabled">
      <slot />
    </fieldset>

	<div v-if="errors || warnings || successes" class="w-full my-24">
		<div class="error-message" v-if="errors">
			<p v-for="message of errors" :key="message">{{ message }}</p>
		</div>
		<WarningMessage v-if="warnings">
			<p v-for="message of warnings" :key="message">{{ message }}</p>
		</WarningMessage>
		<SuccessMessage v-if="successes">
			<p v-for="message of successes" :key="message">{{ message }}</p>
		</SuccessMessage>
	</div>

    <fieldset
      v-if="showFooter"
      :class="['form-footer flex-split gap-16 wrap', footerClass]"
      :disabled="disabled || isLoading"
    >
      <slot name="footer">
        <slot name="actions" />
		<router-link v-if="$route.name =='findHelpDetails'" :to="{ name: $routes.Dashboard.name }" class="btn btn-large align-left" style="flex-basis: 78px">Exit</router-link>
		<button type="submit" class="btn btn-large btn-green">{{ verb }}</button>
      </slot>
    </fieldset>
  </form>
</template>

<script>
import { toNonEmptyStringArray } from '@/helpers/convert';

export default {
	name: 'BaseForm',
	props: {
		bodyClass: {
			default: null,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		errorMessage: [String, Array],
		footerClass: {
			default: null,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		successMessage: [String, Array],
		verb: {
			type: String,
			default: 'Submit',
		},
		warningMessage: [String, Array],
	},
	computed: {
		errors() {
			return this.getMessages(this.errorMessage);
		},
		isLoading() {
			return !!this.loading;
		},
		listeners() {
			return {
				...this.$listeners,
				submit: (event) => {
					if (!event.defaultPrevented) {
						event.preventDefault();
						this.$emit('submit', event);
					}
				},
			};
		},
		showFooter() {
			const slots = this.$slots;
			if (this.$route.name == 'onboardingEvent') return false;
			return !!(slots.footer || slots.actions || this.verb);
		},
		successes() {
			return this.getMessages(this.successMessage);
		},
		warnings() {
			return this.getMessages(this.warningMessage);
		},
	},
	methods: {
		getMessages(value) {
			const messages = new Set(toNonEmptyStringArray(value));
			return messages.size ? Array.from(messages) : null;
		},
	},
};
</script>
